import { Directive, Input, OnInit, Optional, TemplateRef, ViewContainerRef } from "@angular/core";
import { environment } from "@env/environment";
import { IsBetaWindow } from "@env/version";

type CEnv = "beta" | "dev" | "production";
export const checkEnvironment = (environmentsAllowed: CEnv[]) => {
	if (environmentsAllowed.includes("beta") && IsBetaWindow()) {
		return true;
	}
	if (environmentsAllowed.includes("production") && environment.production && !IsBetaWindow()) {
		return true;
	}
	if (environmentsAllowed.includes("dev") && !environment.production) {
		return true;
	}
	return false;
};
@Directive({
	selector: "[isBeta]",
})
export class IsBetaDirective implements OnInit {
	@Input()
	isBeta: boolean;
	constructor(
		private viewContainer: ViewContainerRef,
		@Optional() private templateRef: TemplateRef<any>
	) {}
	ngOnInit() {
		this.updateView();
	}
	private updateView() {
		if (
			(environment.production && !IsBetaWindow() && this.isBeta !== false) ||
			(!environment.production && window.devEnv === "beta")
		) {
			this.viewContainer.clear();
		} else if (this.templateRef) {
			this.viewContainer.createEmbeddedView(this.templateRef);
		}
	}
}
